import { Code, type ConnectError } from '@connectrpc/connect'
import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import {
  deleteDemandBreakdownMode,
  listDemandBreakdownModes,
  saveDemandBreakdownMode,
} from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_service-DemandBreakdownModeService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 成功した時と、他の利用者が先に変更していた (Aborted) 時に一覧を取り直す。
 * Aborted の時は一覧が古いので、取り直して相手の変更を見せる (AC-7)。
 */
function useRefreshBoardOptions(): {
  onSuccess: () => Promise<void>
  onError: (err: ConnectError) => Promise<void>
} {
  const queryClient = useQueryClient()
  const refresh = (): Promise<void> =>
    queryClient.invalidateQueries({
      queryKey: createConnectQueryKey({
        schema: listDemandBreakdownModes,
        cardinality: 'finite',
      }),
    })
  return {
    onSuccess: refresh,
    onError: (err) =>
      err.code === Code.Aborted ? refresh() : Promise.resolve(),
  }
}

/** 想定モードの保存。 */
export function useSaveDemandBreakdownMode(): InvalidatingMutationResultFor<
  typeof saveDemandBreakdownMode
> {
  return useMutation(saveDemandBreakdownMode, useRefreshBoardOptions())
}

/** 想定モードの削除 (一括想定 (既定) に戻す)。 */
export function useDeleteDemandBreakdownMode(): InvalidatingMutationResultFor<
  typeof deleteDemandBreakdownMode
> {
  return useMutation(deleteDemandBreakdownMode, useRefreshBoardOptions())
}
